module.exports = __webpack_public_path__ + "static/media/Manual M4 WiLink 1simple.b3c9d4df.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/Manual M4 WiLink 1simple.pdf
// module id = 318
// module chunks = 0